import React from 'react'
import ReactPlayer from 'react-player'

export const BackgroundCarosel = () => {
  let links = ['night.mp4', 'into.mp4']
  let count = 0
  const [id, setId] = React.useState(count)

  function changeId(count: number) {
    count++
    if (count === 2) {
      count = 0
    }

    setId(count)
  }
  return (
    <div className="relative w-full h-screen">
      <div
        className="absolute z-10 w-full pt-32 bg-center"
        style={{ height: '100%' }}
      >
        <h1 className="mb-8 text-3xl font-light tracking-wider text-center text-white sm:text-4xl md:text-5xl lg:text-6xl p">
          Midnight cravings,
          <br /> delivered to your door!
        </h1>
        <h2 className="text-2xl tracking-wider text-center text-white lg:text-5xl">
          8PM-6AM EVERYDAY!
        </h2>
        <div className="absolute w-full bottom-16 lg:bottom-3">
          {/* <DownloadAppLinks /> */}
        </div>
      </div>
      {/* <img
        src="https://images.unsplash.com/photo-1520033222127-8f6d08b425f6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2762&q=80"
        alt="bg carosel"
      /> */}
      <ReactPlayer
        url={links[id]}
        playing={true}
        height={'100%'}
        playbackRate={1}
        onEnded={() => changeId(id)}
        config={{
          file: {
            attributes: {
              autoPlay: true,
              muted: true,
            },
          },
        }}
        width={'100%'}
      />
    </div>
  )
}
